// removed by extract-text-webpack-plugin
module.exports = {"additionalInfoWrapper":"AdditionalInfo__additionalInfoWrapper___2tgFy","additionalInfo":"AdditionalInfo__additionalInfo___1mHlP","property":"AdditionalInfo__property___2q9_7","additionalInfoSubsectionWrapper":"AdditionalInfo__additionalInfoSubsectionWrapper___2GmgI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SummarySubSections/SummarySubSection/AdditionalInfo/AdditionalInfo.less
// module id = 1209
// module chunks = 0